export function createShadowRoot(): { host: HTMLDivElement; root: ShadowRoot } {
  const host = document.createElement('div');
  host.id = 'attende-widget';
  host.setAttribute('aria-live', 'polite');
  host.style.cssText = 'all: initial; position: fixed; z-index: 2147483000; font-family: system-ui, -apple-system, sans-serif;';
  document.body.appendChild(host);
  const root = host.attachShadow({ mode: 'open' });
  return { host, root };
}
